import combineEvents from '@redux-beacon/combine-events';
import { SEARCH_SUCCESS, CHANGE_SEARCH_PARAMS } from '../constants/search';
import {
  CHANGE_FILTER,
  CLEAR_FILTER,
  CLEAR_FILTERS,
} from '../constants/filters';
import { getParams } from '../selectors/searchParams';
import { getFiltersFromUrl } from '../utils';

const SEARCH_PAGE_CATEGORY = 'search_page';

const searchPageAction = (action) => ({
  event: action.type,
  eventCategory: SEARCH_PAGE_CATEGORY,
});

const getFirstHotelData = (data) => {
  if (!data) {
    return null;
  }

  return {
    product: {
      ids: {
        sajtLevelTravel: String(data.id),
      },
    },
    price: parseFloat(data.min_price),
  };
};

const filterChanged = (action) => ({
  ...searchPageAction(action),
  eventLabel: `Filter changed: ${action.payload.path}`,
});

const filterCleared = (action) => ({
  ...searchPageAction(action),
  eventLabel: `Filter removed: ${action.payload}`,
});

const filtersCleared = (action) => ({
  ...searchPageAction(action),
  eventLabel: 'Filters has been removed',
});

const searchResults = (action, state) => {
  const { hotels } = action.payload;
  const searchParams = getParams(state);

  return {
    ...searchPageAction(action),
    eventLabel: `Search results: ${hotels.length} hotels found`,
    eventParams: {
      ...searchParams,
      filters: getFiltersFromUrl(),
    },
    firstHotel: getFirstHotelData(hotels[0]),
  };
};

const additionalInfo = (action) => {
  const { sort_variant_tag } = action.payload;
  return {
    sort_variant_tag,
  };
};

// Map the event to a Redux action
export default {
  [SEARCH_SUCCESS]: combineEvents(searchResults, additionalInfo),
  [CHANGE_FILTER]: filterChanged,
  [CLEAR_FILTER]: filterCleared,
  [CLEAR_FILTERS]: filtersCleared,
  [CHANGE_SEARCH_PARAMS]: searchPageAction,
};
